import styled from "react-emotion";

const MutedText = styled("p")`
  font-size: 0.8rem;
  color: #f7f7f7;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
`;

export default MutedText;
